module.exports = __webpack_public_path__ + "static/MODALITAPRESENTAZIONEDOMANDA-84398bff9367ec28d17f63b5dc97b1cb.pdf";